<div class="chart-container" id="{{ this.chartId }}">
    <div class="progress-group" *ngFor="let d of lstData">
        {{ d.name }}
        <span class="float-right">
            <b>{{ d.totalCpass | number: '1.0-0' }}</b>
            /{{ d.total | number: '1.0-0' }}
        </span>
        <div class="progress progress-sm">
            <div class="progress-bar" [style]="d.css"></div>
        </div>
    </div>
</div>
